import React, { Component } from 'react';
import { Modal, message, Button } from 'antd';
import { Message } from 'semantic-ui-react';
import { ACTION_STATUS } from '../../../../../utils/ActionStatus';

class DelGroupCompanyRegisterModalDialog extends Component {
    componentDidUpdate() {
        const {
            submitDelGroupCompanyRegisterStatus,
        } = this.props;
        if (submitDelGroupCompanyRegisterStatus === ACTION_STATUS.SUCCESS) {
            message.success('Delete Group Company Register succeeded');
            this.props.initSubmitDelGroupCompanyRegisterActionStatus();
            this.props.resetDelGroupCompanyRegisterModal();
            this.props.queryGroupCompanyRegister();
        }
        if (submitDelGroupCompanyRegisterStatus === ACTION_STATUS.ERROR) {
            this.props.initSubmitDelGroupCompanyRegisterActionStatus();
        }
    }

    submitDelGroupCompanyRegister = () => {
        const { id } = this.props.delGroupCompanyRegisterModal.fields;
        this.props.submitDelGroupCompanyRegister({ id });
    }

    render() {
        const { isOpened, respErrMsg } = this.props.delGroupCompanyRegisterModal;
        const isSubmitLoading = this.props.submitDelGroupCompanyRegisterStatus === ACTION_STATUS.LOGINING;

        return (
            <div>
                <Modal
                    title='Del Group Company Register'
                    centered
                    width={520}
                    visible={isOpened}
                    destroyOnClose={true}
                    maskClosable={false}
                    onCancel={() => this.props.resetDelGroupCompanyRegisterModal()}
                    footer={[
                        <Button key='Cancel' onClick={() => this.props.resetDelGroupCompanyRegisterModal()}>
                            Cancel
                        </Button>,
                        <Button key='Submit' type='primary' loading={isSubmitLoading} onClick={this.submitDelGroupCompanyRegister}>
                            Submit
                        </Button>,
                    ]}
                >
                    <div>Delete the selected Group Company Register record permanently.</div>
                    {!!respErrMsg &&
                        <Message negative style={{ marginTop: 16 }}>
                            <Message.Header>Response Error Message</Message.Header>
                            <p>{respErrMsg}</p>
                        </Message>
                    }
                </Modal>
            </div>
        );
    }
}

export default DelGroupCompanyRegisterModalDialog;
